import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";
import api from "@/lib/api";

const fmt = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export default function Reports() {
  const [stats, setStats] = useState(null);
  useEffect(() => { (async () => setStats((await api.get("/dashboard/stats")).data))(); }, []);

  return (
    <div data-testid="reports-page">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Reports</h1>
        <p className="text-sm text-slate-500 mt-1">Revenue trends and performance snapshots.</p>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Total Revenue</div>
          <div className="font-display text-3xl font-extrabold mt-2">{fmt(stats?.total_revenue)}</div>
        </div>
        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">This Month</div>
          <div className="font-display text-3xl font-extrabold mt-2 text-emerald-600">{fmt(stats?.revenue_month)}</div>
        </div>
        <div className="bg-white border border-slate-200 rounded-md p-5">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Outstanding</div>
          <div className="font-display text-3xl font-extrabold mt-2 text-amber-600">{fmt(stats?.outstanding)}</div>
        </div>
      </div>

      <div className="mt-6 bg-white border border-slate-200 rounded-md p-5">
        <div className="font-display font-bold text-lg mb-4">Monthly revenue</div>
        <div style={{ width: "100%", height: 320 }}>
          <ResponsiveContainer>
            <BarChart data={stats?.chart || []}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="month" stroke="#94a3b8" fontSize={12} />
              <YAxis stroke="#94a3b8" fontSize={12} tickFormatter={(v) => `$${v}`} />
              <Tooltip contentStyle={{ border: "1px solid #e2e8f0", borderRadius: 6 }} formatter={(v) => fmt(v)} />
              <Bar dataKey="revenue" fill="#2563eb" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
